import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';


import { Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import '../modalDatosIniciales.css';

import { Model } from '../../../../models/model';
import { InvoiceModalNuevo } from '../../../invoices/form/InvoiceModalNuevo';
import { useInvoices } from '../../../../hooks/useInvoices';
import { ComprasModalNuevoGasto } from '../../../compras/form/ComprasModalNuevoGasto';
import { useBuy } from '../../../../hooks/useBuy';
import { FlowSectionGeneral } from './FlowSectionGeneral';

import { ChevronDown, ChevronUp } from 'lucide-react'

export const DialogFlowGeneral = ({ open, setOpen, item, tasksList = null, currentTasks = null, refreshObj = null }) => {

    const generalParams = useSelector(state => state.general)
    const generalDetail = generalParams.detail

    const detailBudget = useSelector(state => state.ppto.detail)
    const { referencia, cliente } = detailBudget

    const { detailInvoice, initCreateInvoiceFromFlow } = useInvoices()
    const { detailBuy, initCreateBuyFromFlow } = useBuy()

    const [openNewInvoice, setOpenNewInvoice] = useState(false)
    const [openExtendedMode, setOpenExtendedMode] = useState(false)
    const [openResumen, setOpenResumen] = useState(false)

    const [form, setForm] = useState({
        ...item,
        tipo_flujo: 'ingreso',
        total_proyectado: item?.total_proyectado || 0,
        saldo_por_proyectar: item?.saldo_por_proyectar || 0,
        total_proyectado_egresos: item?.total_proyectado_egresos,
        saldo_por_proyectar_egresos: item?.saldo_por_proyectar_egresos,

        total_facturado: item?.total_facturado,
        total_por_facturar: item?.total_por_facturar,
        total_cobrado: item?.total_cobrado,
        total_por_cobrar: item?.total_por_cobrar,

        total_gastado: item?.total_gasto_real,
        total_por_gastar: item?.total_por_gastar,
        total_pagado: item?.total_pagado,
        total_por_pagar: item?.total_por_pagar

    });

    const handleGetInfoItem = useCallback(async (id) => {

        const results = await Model.getOne({
            url: `budgets-items/${item?.id || id}`,
        })

        if (results) {

            setForm(prev => ({
                ...prev,
                total_proyectado: results?.total_proyectado || 0,
                saldo_por_proyectar: results?.saldo_por_proyectar || 0,
                total_proyectado_egresos: results?.total_proyectado_egresos || 0,
                saldo_por_proyectar_egresos: results?.saldo_por_proyectar_egresos || 0,

                total_facturado: results?.total_facturado || 0,
                total_por_facturar: results?.total_por_facturar || 0,
                total_cobrado: results?.total_cobrado || 0,
                total_por_cobrar: results?.total_por_cobrar || 0,

                total_gastado: results?.total_gasto_real || 0,
                total_por_gastar: results?.total_por_gastar || 0,
                total_pagado: results?.total_pagado || 0,
                total_por_pagar: results?.total_por_pagar || 0
            }))

        }

    }, [item?.id])

    // const handleSelectItem = ({ target }) => {
    //     const itemId = target.value

    //     if (itemId) {
    //         const itemFound = itemsPpto?.find(it => it.id === itemId)
    //         setForm({
    //             ...form,
    //             id: itemId,
    //             nombre: itemFound?.nombre,
    //             precio_subtotal: itemFound?.precio_subtotal || 0,
    //             total_proyectado: itemFound?.total_proyectado || 0,
    //             saldo_por_proyectar: itemFound?.saldo_por_proyectar || 0,
    //             costo_subtotal: itemFound?.costo_subtotal || 0,
    //             total_proyectado_egresos: itemFound?.total_proyectado_egresos || 0,
    //             saldo_por_proyectar_egresos: parseFloat(itemFound?.costo_subtotal) - parseFloat(itemFound?.total_proyectado_egresos || 0),

    //             total_facturado: itemFound?.total_facturado || 0,
    //             total_por_facturar: itemFound?.total_por_facturar || 0,
    //             total_cobrado: itemFound?.total_cobrado || 0,
    //             total_por_cobrar: itemFound?.total_por_cobrar || 0,

    //             total_gastado: itemFound?.total_gasto_real || 0,
    //             total_por_gastar: itemFound?.total_por_gastar || 0,
    //             total_pagado: itemFound?.total_pagado || 0,
    //             total_por_pagar: itemFound?.total_por_pagar || 0

    //         })
    //     }
    // }

    const handleOpenNewInvoice = async (flowSelected, flowType) => {
        // console.log({ flowSelected })

        const infoFlow = {
            ...flowSelected,
            referencia: referencia + " / " + flowSelected.nombre_tarea
        }

        if (flowType === 'ingreso') {
            await initCreateInvoiceFromFlow(detailBudget, generalDetail, infoFlow)
            setOpenNewInvoice(true)

        } else {

            let resultTask = null
            if (flowSelected?.id_tarea) {
                resultTask = await Model.getOne({ url: `tasks/${flowSelected?.id_tarea}` })
            }

            const refNombre = resultTask ? (flowSelected?.referencia + " / " + resultTask?.nombre).toUpperCase() : (flowSelected?.referencia || '---')

            const itemsSelected = [{
                id_proveedor: flowSelected?.id_contacto || null,
                nombre: refNombre,
                total_por_gastar: flowSelected?.monto_neto,
                id_titulo: null,
                id_servicio: null,
                id_categoria: item?.id_categoria,
                origen: null,
                id_tipo_documento: flowSelected.id_doc,
                id_item_ppto: flowSelected?.id_item_ppto,
            }]

            const params = {
                origen: 'ventas',
                itemsSelected,
                detailBudget,
                generalParams,
                flowSelected
            }

            await initCreateBuyFromFlow(params)
            setOpenExtendedMode(true)

        }

    }

    const handleOpenNewInvoiceSelected = async (itemsSelectedFlow, flowType) => {
        const flowSelected = itemsSelectedFlow[0]

        const infoFlow = {
            ...flowSelected,
            referencia: item?.nombre + " / " + flowSelected.porcentaje_flow + "%"
        }

        if (flowType === 'ingreso') {
            await initCreateInvoiceFromFlow(detailBudget, generalDetail, infoFlow)
            setOpenNewInvoice(true)

        } else {

            let itemsSelected = []
            for (let x = 0; x < itemsSelectedFlow.length; x++) {
                const flow = itemsSelectedFlow[x]
                // console.log({ flow })
                // const resultTask = await Model.getOne({ url: `tasks/${flow?.id_tarea}` })

                itemsSelected = [
                    ...itemsSelected,
                    {
                        id_proveedor: flow?.id_contacto || null,
                        nombre: flow.referencia.toUpperCase(),
                        total_por_gastar: flow?.monto_neto,
                        id_titulo: null,
                        id_servicio: null,
                        id_categoria: item?.id_categoria,
                        origen: null,
                        id_tipo_documento: flow.id_doc,
                        id_item_ppto: flow?.id_item_ppto,
                        flow_id: flow.id
                    }
                ]

            }


            const params = {
                origen: 'ventas',
                itemsSelected,
                detailBudget,
                generalParams,
                flowSelected
            }

            await initCreateBuyFromFlow(params)
            setOpenExtendedMode(true)

        }

    }

    useEffect(() => {
        if (item.id) {
            handleGetInfoItem(item.id)
        }
    }, [item.id, handleGetInfoItem])


    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
            fullScreen={true}
        >
            <div className='border-1 border-gray-300 m-3 rounded-2xl'>

                <div className='border-b border-gray-300 p-2 mb-3 flex items-center justify-between'>

                    <div className='ms-2'>
                        <h3 className='mt-1 text-xl font-bold'>Flujos proyectados</h3>
                        <h5 className='text-xs'>
                            <label>PROYECTO:</label>
                            <span className='ms-1 uppercase'>{referencia}</span>
                        </h5>
                        <h5 className='text-xs'>
                            <label>CLIENTE:</label>
                            <span className='ms-1 uppercase'>{cliente}</span>
                        </h5>
                    </div>

                    <IconButton
                        className='me-2'
                        aria-label="close"
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon />
                    </IconButton>

                </div>

                <button className='flex m-3 items-center' onClick={() => setOpenResumen(!openResumen)}>
                    {openResumen ? (
                        <ChevronUp className='w-4 h-4' />
                    ) : (
                        <ChevronDown className='w-4 h-4' />
                    )}
                    <span className='ms-2 text-sm'>Ver resumen</span>
                </button>

                <FlowSectionGeneral
                    form={form}
                    setForm={setForm}
                    handleGetInfoItem={handleGetInfoItem}
                    tasksList={tasksList}
                    currentTasks={currentTasks}
                    handleOpenNewInvoice={handleOpenNewInvoice}
                    handleOpenNewInvoiceSelected={handleOpenNewInvoiceSelected}
                    openResumen={openResumen}
                    setOpenResumen={setOpenResumen}
                />

                {openNewInvoice && (
                    <InvoiceModalNuevo
                        title='Nueva factura'
                        open={openNewInvoice}
                        setOpen={setOpenNewInvoice}
                        initialState={detailInvoice}
                        loadIniBudget={() => false}
                    />
                )}

                {openExtendedMode && (
                    <ComprasModalNuevoGasto
                        title='Nuevo gasto'
                        open={openExtendedMode}
                        setOpenExtendedMode={setOpenExtendedMode}
                        initialState={detailBuy}
                        loadIniBudget={() => false}
                    />
                )}

            </div>
        </Dialog>
    )
}

